const API_BASE_URI = 'https://api.sercom.io/api';
const CHECK_TIMEOUT_MS = 5000;

const BackendAvailabilityService = {
  async isReady(): Promise<boolean> {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), CHECK_TIMEOUT_MS);

    try {
      const response = await fetch(`${API_BASE_URI}/health/ready`, {
        cache: 'no-store',
        signal: controller.signal,
      });

      return response.ok;
    } catch {
      return false;
    } finally {
      window.clearTimeout(timeout);
    }
  },
};

export default BackendAvailabilityService;
